import { Button } from 'MaterialUIComponents';
import { VideoViewType } from '$Utilities/models/videoViews';
import { React } from 'Imports';
import * as scssStyles from '$CSS/settings.scss';

const styles = require('./Layouts.scss') as {
    videoViewButton: string;
    videoViewButtonActive: string;
    optionsContainerGeotab: string;
    optionsContainerEncompass: string;
    videoViewButtonFull: string;
};

interface VideoViewsOptionsProps {
    numberOfChannels: number;
    activeViewOption?: VideoViewType;
    onViewChange: (type: VideoViewType) => void;
    activeFullScreen?: boolean;
}

const VideoViewsOptions = (props: VideoViewsOptionsProps) => {
    const handleViewOptionChange = (type: VideoViewType) => {
        props.onViewChange(type);
    };

    const ViewOptionButton = ({ type, text }: { type: VideoViewType; text?: string }) => {
        const activeOption = props.activeFullScreen ? ('Full Screen' as VideoViewType) : props.activeViewOption;
        let className = type === activeOption ? styles.videoViewButtonActive : styles.videoViewButton;
        if (type === ('Full Screen' as VideoViewType)) {
            className += ` ${styles.videoViewButtonFull}`;
        }
        return (
            <Button className={className} onClick={() => handleViewOptionChange(type)} disableRipple>
                {text ?? type}
            </Button>
        );
    };
    return (
        <div className={scssStyles.styleEnvironment === 'encompass' ? styles.optionsContainerEncompass : styles.optionsContainerGeotab}>
            <ViewOptionButton type="Single" text="Single View" />
            {props.numberOfChannels > 1 && <ViewOptionButton type="Double" text="Double View" />}
            {props.numberOfChannels > 3 && <ViewOptionButton type="Grid" text="Grid View" />}
            <ViewOptionButton type={'Full Screen' as VideoViewType} />
        </div>
    );
};

export default VideoViewsOptions;
